export const getColor = (formComponents, hasError, dark) => {
  if (hasError) {
    return dark ? formComponents.dark.error.color : formComponents.error.color;
  }

  return dark ? formComponents.dark.color : formComponents.label.color;
};
export default ({ formComponents }) => ({
  root: ({ hasError, dark }) => ({
    ...formComponents.error,
    color: getColor(formComponents, hasError, dark),
    margin: [6, 0, 0, 'auto'],
    paddingLeft: 6
  })
});
